import { render, staticRenderFns } from "./primaryButton.vue?vue&type=template&id=c5837392&scoped=true"
import script from "./primaryButton.vue?vue&type=script&lang=js"
export * from "./primaryButton.vue?vue&type=script&lang=js"
import style0 from "./primaryButton.vue?vue&type=style&index=0&id=c5837392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5837392",
  null
  
)

export default component.exports